import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getApplicationWebhooks } from '@/services/applicationWebhooks';

export const applicationWebhooks = createQueryKeys('applicationWebhooks', {
  list: {
    queryFn: getApplicationWebhooks,
    queryKey: null,
  },
});
